import { RatingFormAlert, ReferralCodeSection } from '@/components';
import Section from '@/components/atoms/Section/Section';
import { TrayScreen } from '@/components/atoms/Tray/interfaces/Tray';
import Tray from '@/components/atoms/Tray/Tray';
import WalletsList from '@/components/organisms/WalletsList/WalletsList';
import {
  TrayNavigationProvider,
  useTrayNavigation,
} from '@/components/providers/common/TrayNavigationProvider';
import APP_CONFIG from '@/config/app';
import { logInfo } from '@/utils/logger';
import { FC, useEffect } from 'react';
import { RatingFormType } from '../RatingForm/RatingForm';
import ConnectedAccountSection from './ConnectedAccountSection';
const visualizeElementsAndSpacing = false;
const borderClassToVisualizeElementsAndSpacing = visualizeElementsAndSpacing
  ? 'border-white border'
  : '';
const mainGap = APP_CONFIG.STYLES.MAIN_GAP;
const mainRoundedness = APP_CONFIG.STYLES.MAIN_ROUNDEDNESS;
const spacingConfig = {
  gap: `gap${mainGap}`,
};
const roundednessConfig = {
  roundedness: `rounded${mainRoundedness}`,
};
const colorConfig = {
  backgroundColor: 'bg-primary/10',
  borderColor: 'border border-primary/10',
};
interface AccountProfileTrayProps {
  isTrayOpen: boolean;
  setIsTrayOpen: (isOpen: boolean) => void;
  logout: () => void;
}
const AccountProfileTrayContent: FC<AccountProfileTrayProps> = ({
  isTrayOpen,
  setIsTrayOpen,
  logout,
}) => {
  const { navigateBack } = useTrayNavigation();
  const closeTray = () => {
    setIsTrayOpen(false);
  };
  const handleLogOut = () => {
    logInfo('User logged out', 'handleLogOut');
    logout();
    setIsTrayOpen(false);
  };
  const handleNavigateBack = () => {
    navigateBack();
  };
  useEffect(() => {
    if (!isTrayOpen) {
      logInfo('Tray closed', 'useEffect');
    }
  }, [isTrayOpen]);
  const screens: TrayScreen[] = [
    {
      content: (
        <div
          className={`flex flex-col 
            ${spacingConfig.gap} 
            ${borderClassToVisualizeElementsAndSpacing}`}
        >
          <ConnectedAccountSection />
          <Section
            headerTitle="Wallets"
            body={
              <WalletsList
                shouldSelectWallet={false}
                showWalletBlockchain
              />
            }
            className={`${colorConfig.backgroundColor} 
            ${roundednessConfig.roundedness} 
            ${borderClassToVisualizeElementsAndSpacing}`}
          />
          <ReferralCodeSection />
          <Section
            headerTitle="Rating"
            body={<RatingFormAlert type={RatingFormType.GENERAL} />}
          />
        </div>
      ),
      onNavigateBack: handleNavigateBack,
      title: 'Account',
      includeFooterCloseButton: true,
      extraButton1Label: 'Log out',
      extraButton1OnClick: handleLogOut,
      extraButton1Icon: 'LogOut',
    },
  ];
  return <Tray isOpen={isTrayOpen} onClose={closeTray} screens={screens} />;
};
const AccountProfileTray: FC<AccountProfileTrayProps> = (props) => (
  <TrayNavigationProvider>
    <AccountProfileTrayContent {...props} />
  </TrayNavigationProvider>
);
export default AccountProfileTray;
